import { useRef } from "react";
import classNames from "classnames";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";
import FontSizeAdjustorPopup from "./FontSizeAdjustorPopup";
import { usePopupPosition } from "../../hooks/popupPositionHooks/usePopupPosition";

const FontSizeAdjustorButton = ({ onClick, styling }) => {
  const iconRef = useRef(null);
  const iconFontSize = classNames("tg-icons-FontSize", "iconSize");
  const { isMobileView } = useAppModernisation();
  const fontSizeAdjustor = useFontSizeAdjustor();
  const { position } = usePopupPosition(iconRef, fontSizeAdjustor.isOpen);

  return (
    <>
      <button
        type="button"
        className={styling}
        aria-label="Font Size Adjustor"
        ref={iconRef}
        onClick={onClick}
      >
        <i className={iconFontSize}></i>
      </button>

      {!isMobileView && fontSizeAdjustor.isOpen && <FontSizeAdjustorPopup position={position} />}
    </>
  );
};

export default FontSizeAdjustorButton;
